var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 34.643V5.357C8 4.608 8.624 4 9.393 4h12.179L32 14.16v20.483c0 .749-.624 1.357-1.393 1.357H9.393C8.624 36 8 35.392 8 34.643z",
    fill: "#CB0606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.574 4 10.428 10.16h-9.035c-.769 0-1.393-.608-1.393-1.357V4z",
    fill: "#FB8D8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.57 31.734h.875V29.81h1.32c1.106 0 1.872-.754 1.872-1.856v-.008c0-1.105-.766-1.847-1.871-1.847H12.57v5.636zm1.977-4.898c.758 0 1.2.41 1.2 1.113v.008c0 .707-.442 1.117-1.2 1.117h-1.102v-2.238h1.102zm3.219 4.898H19.8c1.68 0 2.652-1.039 2.652-2.828v-.008c0-1.77-.98-2.8-2.652-2.8h-2.035v5.636zm.875-.754v-4.128h1.062c1.168 0 1.86.761 1.86 2.058v.008c0 1.309-.68 2.063-1.86 2.063h-1.062zm5 .754h.875v-2.359h2.422v-.738h-2.422v-1.785h2.644v-.754h-3.52v5.636z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.e8161b132fb1320f73d43d4e3f6f4eae.svg";
export { ForwardRef as ReactComponent };